import { AppArea, ExperimentConfig, ExperimentName } from '@/funnels/@types'

import web_autotest_female_funnel_check from './web_autotest_female_funnel_check'
import web_wheel_of_fortune_walking_female from './web_wheel_of_fortune_walking_female'
import web_wheel_of_fortune_activity_female from './web_wheel_of_fortune_activity_female'
import web_wheel_of_fortune_yoga_female from './web_wheel_of_fortune_yoga_female'
import web_wheel_of_fortune_male from './web_wheel_of_fortune_male'
import web_summary_checkpoints_walking from './web_summary_checkpoints_walking'
import web_summary_checkpoints_yoga from './web_summary_checkpoints_yoga'
import web_ai_generated_female_funnel from './web_ai_generated_female_funnel'
import web_apple_pay_renaming from './web_apple_pay_renaming'
import web_higher_prices_upsells_eu from './web_higher_prices_upsells_eu'
import web_higher_prices_upsells_en from './web_higher_prices_upsells_en'
import web_higher_prices_upsells_row from './web_higher_prices_upsells_row'
import web_fsa_hsa_fd from './web_fsa_hsa_fd'
import web_upsell_double_offering from './web_upsell_double_offering'
import web_scrolling_urgency_message_female_fasting from './web_scrolling_urgency_message_female_fasting'
import web_ask_age_starting_screens from './web_ask_age_starting_screens'
import web_female_risk_free_offer from './web_female_risk_free_offer'
import web_male_fasting_risk_free_offer from './web_male_fasting_risk_free_offer'
import web_fallback_on_payment from './web_fallback_on_payment'
import web_en_countries_price_optimization from './web_en_countries_price_optimization'
import web_see_visible_results_in_4_weeks from './web_see_visible_results_in_4_weeks'
import web_bulk_change_walking_female from './web_bulk_change_walking_female'
import web_tiers_as_upgrade_pilates from './web_tiers_as_upgrade_pilates'
import web_wheel_of_fortune_chair_workouts from './web_wheel_of_fortune_chair_workouts'
import web_walking_female_bmi_to_the_end from './web_walking_female_bmi_to_the_end'
import web_separate_payment_block_on_sp from './web_separate_payment_block_on_sp'
import web_buy_6_get_12_pilates from './web_buy_6_get_12_pilates'
import web_welcome_fasting_for_weight_loss from './web_welcome_fasting_for_weight_loss'
import web_pricing_on_fasting_funnels_with_sp from './web_pricing_on_fasting_funnels_with_sp'
import web_pricing_on_pilates_funnel_with_sp from './web_pricing_on_pilates_funnel_with_sp'
import web_removing_upgrades from './web_removing_upgrades'
import web_removing_upgrades_au_ca_gb_eu from './web_removing_upgrades_au_ca_gb_eu'
import web_removing_upgrades_row from './web_removing_upgrades_row'
import web_send_calculated_vat_eu from './web_send_calculated_vat_eu'
import web_yoga_printable_guide_welcome from './web_yoga_printable_guide_welcome'
import web_walking_female_weight_loss_plan from './web_walking_female_weight_loss_plan'
import web_walking_female_risk_free_offer from './web_walking_female_risk_free_offer'
import web_walking_to_lose_weight_gdn from './web_walking_to_lose_weight_gdn'
import web_walking_to_lose_weight_keyword from './web_walking_to_lose_weight_keyword'
import web_free_month_chair_workouts from './web_free_month_chair_workouts'
import web_pricing_on_fasting_funnels_with_sp_nonus from './web_pricing_on_fasting_funnels_with_sp_nonus'
import web_walking_female_indoor from './web_walking_female_indoor'
import web_chair_workouts_male_scratch_card from './web_chair_workouts_male_scratch_card'
import web_pricing_for_desktop from './web_pricing_for_desktop'
import web_welcome_for_gdn_main_gs from './web_welcome_for_gdn_main_gs'
import web_walking_male_one_predict_instead_of_two from './web_walking_male_one_predict_instead_of_two'
import web_welcome_for_search_fasting_schedule from './web_welcome_for_search_fasting_schedule'
import web_chair_yoga_challenge_landing from './web_chair_yoga_challenge_landing'
import web_welcome_for_search_fasting_lose_weight from './web_welcome_for_search_fasting_lose_weight'
import web_fasting_fem_scratch_card_before_the_paywall from './web_fasting_fem_scratch_card_before_the_paywall'
import web_welcome_for_demgen_walking from './web_welcome_for_demgen_walking'
import web_dynamic_email_capture from './web_dynamic_email_capture'
import web_yoga_female_scratch_card_before_the_paywall from './web_yoga_female_scratch_card_before_the_paywall'
import web_black_friday_for_fasting_f from './web_black_friday_for_fasting_f'
import web_black_friday_for_pilates_f from './web_black_friday_for_pilates_f'
import web_black_friday_for_walking_f from './web_black_friday_for_walking_f'
import web_plan_benefits_below_prices from './web_plan_benefits_below_prices'
import web_all_payment_options_at_once from './web_all_payment_options_at_once'
import web_walking_loader_with_women from './web_walking_loader_with_women'

const experimentsConfig: Partial<Record<AppArea, { [key: ExperimentName<string>]: ExperimentConfig[] }>> = {
	main: {
		web_welcome_fasting_for_weight_loss,
		web_welcome_for_gdn_main_gs,
		web_welcome_for_search_fasting_schedule,
		web_welcome_for_search_fasting_lose_weight,
	},
	female: {
		web_autotest_female_funnel_check,
		web_scrolling_urgency_message_female_fasting,
		web_female_risk_free_offer,
		web_fallback_on_payment,
		web_higher_prices_upsells_eu,
		web_higher_prices_upsells_en,
		web_higher_prices_upsells_row,
		web_fsa_hsa_fd,
		web_upsell_double_offering,
		web_ai_generated_female_funnel,
		web_en_countries_price_optimization,
		web_pricing_on_fasting_funnels_with_sp,
		web_send_calculated_vat_eu,
		web_pricing_on_fasting_funnels_with_sp_nonus,
		web_removing_upgrades_au_ca_gb_eu,
		web_removing_upgrades_row,
		web_fasting_fem_scratch_card_before_the_paywall,
		web_dynamic_email_capture,
		web_pricing_for_desktop,
		web_black_friday_for_fasting_f,
	},
	male: {
		web_wheel_of_fortune_male,
		web_higher_prices_upsells_eu,
		web_higher_prices_upsells_en,
		web_higher_prices_upsells_row,
		web_en_countries_price_optimization,
		web_separate_payment_block_on_sp,
		web_pricing_on_fasting_funnels_with_sp,
		web_removing_upgrades,
		web_removing_upgrades_au_ca_gb_eu,
		web_removing_upgrades_row,
		web_send_calculated_vat_eu,
		web_ask_age_starting_screens,
		web_pricing_on_fasting_funnels_with_sp_nonus,
		web_male_fasting_risk_free_offer,
	},

	'main-activity': {},
	'activity-female-v2': {
		web_wheel_of_fortune_activity_female,
		web_ask_age_starting_screens,
	},
	'activity-male': {},
	'activity-female-pilates': {
		web_higher_prices_upsells_eu,
		web_higher_prices_upsells_en,
		web_higher_prices_upsells_row,
		web_upsell_double_offering,
		web_en_countries_price_optimization,
		web_tiers_as_upgrade_pilates,
		web_buy_6_get_12_pilates,
		web_pricing_on_pilates_funnel_with_sp,
		web_ask_age_starting_screens,
		web_black_friday_for_pilates_f,
	},

	'main-yoga': {
		web_yoga_printable_guide_welcome,
		web_chair_yoga_challenge_landing,
	},
	'main-yoga-g': {},
	'activity-female-yoga': {
		web_apple_pay_renaming,
		web_wheel_of_fortune_yoga_female,
		web_summary_checkpoints_yoga,
		web_higher_prices_upsells_eu,
		web_higher_prices_upsells_en,
		web_higher_prices_upsells_row,
		web_send_calculated_vat_eu,
		web_pricing_for_desktop,
		web_yoga_female_scratch_card_before_the_paywall,
		web_fallback_on_payment,
	},
	'activity-female-yoga-al': {},
	'activity-male-yoga': {},

	'activity-female-somatic-yoga': {},

	'main-walking': {
		web_walking_to_lose_weight_gdn,
		web_walking_to_lose_weight_keyword,
	},
	'activity-female-walking': {
		web_apple_pay_renaming,
		web_wheel_of_fortune_walking_female,
		web_summary_checkpoints_walking,
		web_higher_prices_upsells_eu,
		web_higher_prices_upsells_en,
		web_higher_prices_upsells_row,
		web_upsell_double_offering,
		web_en_countries_price_optimization,
		web_see_visible_results_in_4_weeks,
		web_walking_female_bmi_to_the_end,
		web_removing_upgrades,
		web_removing_upgrades_au_ca_gb_eu,
		web_removing_upgrades_row,
		web_send_calculated_vat_eu,
		web_walking_female_weight_loss_plan,
		web_walking_female_risk_free_offer,
		web_ask_age_starting_screens,
		web_walking_female_indoor,
		web_bulk_change_walking_female,
		web_welcome_for_demgen_walking,
		web_black_friday_for_walking_f,
		web_plan_benefits_below_prices,
		web_all_payment_options_at_once,
		web_walking_loader_with_women,
		web_fallback_on_payment,
	},

	'activity-female-walking-al': {},

	'activity-female-walking-japanese': {},
	'activity-female-walking-japanese-v2': {},

	'female-printable-walking': {},

	'main-tai-chi-walking': {},
	'activity-female-tai-chi-walking': {},
	'activity-female-tai-chi-walking-v2': {},
	'activity-female-tai-chi-walking-al': {},

	'activity-male-tai-chi-walking': {},

	'activity-male-walking': {
		web_higher_prices_upsells_eu,
		web_higher_prices_upsells_en,
		web_higher_prices_upsells_row,
		web_separate_payment_block_on_sp,
		web_removing_upgrades,
		web_removing_upgrades_au_ca_gb_eu,
		web_removing_upgrades_row,
		web_send_calculated_vat_eu,
		web_ask_age_starting_screens,
		web_walking_male_one_predict_instead_of_two,
	},

	'activity-male-tai-chi-yoga': {},

	'activity-male-chair-workouts': {
		web_wheel_of_fortune_chair_workouts,
		web_separate_payment_block_on_sp,
		web_free_month_chair_workouts,
		web_chair_workouts_male_scratch_card,
		web_pricing_for_desktop,
	},

	'activity-female-hiit': {},
	'activity-male-hiit': {},

	'female-mediterranean-diet': {},
	'female-keto-diet': {},
	'female-cortisol-diet': {},
	'male-carnivore-diet': {},

	'female-menopause-diet': {},
	'female-barre': {},
	'female-glp': {},
	'female-al': {},
}

export default experimentsConfig
